import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  const trendIcon = (trend: string) => {
    switch (trend) {
      case 'up': return { icon: 'ri-arrow-up-line', cls: 'text-primary-500' };
      case 'down': return { icon: 'ri-arrow-down-line', cls: 'text-foreground-400' };
      case 'new': return { icon: 'ri-sparkling-line', cls: 'text-accent-500' };
      default: return { icon: 'ri-subtract-line', cls: 'text-foreground-500' };
    }
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              吃瓜热度榜
            </h2>
            <p className="text-sm text-foreground-500">
              实时更新的吃瓜热度排名，最受关注的爆料都在这里
            </p>
          </div>

          <div className="space-y-3">
            {rankingItems.map((item) => {
              const trend = trendIcon(item.trend);
              return (
                <a
                  key={item.id}
                  href="#cards"
                  className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-primary-300 cursor-pointer group"
                >
                  <span className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold whitespace-nowrap ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-600'
                  }`}>
                    {item.rank}
                  </span>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="text-sm md:text-base font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </h3>
                      {item.tag && (
                        <span className={`px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap ${
                          item.tag === '爆'
                            ? 'bg-primary-500 text-background-50'
                            : item.tag === '热'
                            ? 'bg-accent-500 text-background-50'
                            : 'bg-accent-100 text-accent-700'
                        }`}>
                          {item.tag}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center gap-3 text-xs whitespace-nowrap">
                    <span className="flex items-center gap-1">
                      <i className={`${trend.icon} ${trend.cls} text-sm`} />
                    </span>
                    <span className="font-medium text-foreground-700">{item.heat}</span>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}